import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { MarkdownElement } from "@ploy-ui/core";
import ContentBox from "../../ContentBox";
import { Box } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
const placeholderText = (_jsxs(_Fragment, { children: [_jsx(Skeleton, { animation: false, variant: "text", width: "50%", height: "30px" }), _jsx(Skeleton, { animation: false, variant: "text", width: "100%" }), _jsx(Skeleton, { animation: false, variant: "text", width: "100%" }), _jsx(Skeleton, { animation: false, variant: "text", width: "100%" }), _jsx(Skeleton, { animation: false, variant: "text", width: "100%" }), _jsx(Skeleton, { animation: false, variant: "text", width: "70%" })] }));
const Text = (props) => {
    let { boxProps, text, placeholder } = props;
    return (_jsx(ContentBox, { ...boxProps, children: _jsx(Box, { overflow: "auto", children: !placeholder ? _jsx(MarkdownElement, { text: text }) : placeholderText }) }));
};
Text.displayName = "DployDashboardText";
export default Text;
//# sourceMappingURL=Text.js.map